import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { ICustomerState } from './customer.state';

export class CustomerSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly customerState = (state: IRootState): ICustomerState => {
    return state.customer as ICustomerState;
  };

  static readonly model = createSelector(CustomerSelectors.customerState, (customer: ICustomerState) => {
    return customer.model;
  });

  static readonly data = createSelector(CustomerSelectors.customerState, (customer: ICustomerState) => {
    return customer.data;
  });

  static readonly hasCustomerResponse = createSelector(CustomerSelectors.customerState, (customer: ICustomerState) => {
    return customer.hasCustomerResponse;
  });
}
